import { Component, useContext } from 'solid-js';
import { Modal } from '../../ui-components/modal/modal';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { Button } from '../../ui-components/button/button';
import { Text } from '../../ui-components/text/text';

type ShowpadCodeSuccessModalProps = {
    emailTriggered: boolean;
    onClose: () => void;
};

export const ShowpadCodeSuccessModal: Component<ShowpadCodeSuccessModalProps> = (props) => {
    const { localize } = useContext(AppContext);

    const bodyKey = props.emailTriggered
        ? 'showpad-code-success-modal-with-email'
        : 'showpad-code-success-modal-without-email';

    const bodyFallback = props.emailTriggered
        ? 'Your E-Learning access code has been accepted. We have sent you a confirmation email.'
        : 'Your E-Learning access code has been accepted. Your courses should now be available.';

    return (
        <Modal
            visible={true}
            onClose={props.onClose}
            size='small'
            darkenBackground={true}
        >
            <div class='h-20' />
            <Text fontSize='large' fontStyle='bold'>
                {localize('showpad-code-success-modal-header', 'Access code accepted')}
            </Text>

            <Text fontSize='normal' splitParagraph={true}>
                {localize(bodyKey, bodyFallback)}
            </Text>

            <div class='flex justify-center items-center gap-8'>
                <Button
                    label={localize('close-modal-button-text', 'Close')}
                    variant='primary'
                    onClick={props.onClose}
                />
            </div>
        </Modal>
    );
};
